import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { BillingEntity } from 'src/features/billing/utils/types';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';

const RESOURCE = '/customers/billing-entity/';

type MutationFnType = typeof mutationFn;

type UseCreateBillingEntity = MutationConfig<MutationFnType, GeneralASError>;

interface DTO {
    data: FormData;
}

const mutationFn = ({ data }: DTO): Promise<BillingEntity> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: UseCreateBillingEntity = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateBillingEntity };
